// feat_115 — catálogo curado de modelos LLM por proveedor (lista CERRADA).
//
// Lista cerrada → el usuario elige solo de acá, sin texto libre, lo que mata el
// typo que rompía el call al provider. El PRIMERO de cada lista es el default
// sugerido para ese proveedor (debe coincidir con el default del backend en
// RequestExtractorService: anthropic=claude-haiku-4-5-20251001, openai=gpt-4o-mini).
//
// AGREGAR un modelo nuevo = una línea en este mapa. NADA más.

export const LLM_MODELS = {
  openai: [
    "gpt-4o-mini",
    "gpt-4o",
    "gpt-4.1-mini",
    "gpt-4.1",
  ],
  anthropic: [
    "claude-haiku-4-5-20251001",
    "claude-sonnet-4-6",
    "claude-opus-4-8",
  ],
  // Gemini habilitado (feat_146). Default = el más económico para el volumen
  // del extractor. Debe coincidir con DEFAULT_GEMINI_MODEL del backend.
  gemini: [
    "gemini-2.5-flash-lite",
    "gemini-2.5-flash",
    "gemini-3.1-flash-lite",
    "gemini-3.5-flash",
  ],
};

export const modelsForProvider = (provider) =>
  LLM_MODELS[(provider || "").toLowerCase()] || [];

export const defaultModelFor = (provider) => {
  const list = modelsForProvider(provider);
  return list.length > 0 ? list[0] : "";
};

export default LLM_MODELS;
